import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { CustomButtonsForm } from '../../CustomButtonsForm';
import { Grid } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { CustomInputText } from '../../CustomInputText';
import { CustomInputSelect } from '../../CustomInputSelect';
import { useSedes } from '../../../hooks/useSedes';
import { ModalsContext } from '../../../contexts/ModalsContext';
import { SocketContext } from '../../../contexts/SocketContext';
import { LoaderContext } from '../../../contexts/LoaderContext';
import { AlertContext } from '../../../contexts/AlertContext';
import { exportarExcel } from '../../../helpers/exportarExcel';
import dayjs from 'dayjs';
import { useModalStore } from '../../../store/useModalStore';

export const TurnsForm = () => {

    const classes = useStyles();
    const { sedes } = useSedes();
    // const { modalRef } = useContext(ModalsContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { alertRef } = useContext(AlertContext);
    const { handleSubmit, control, formState: { errors } } = useForm();
    const { closeModal } = useModalStore();

    const extraerTurnos = (data) => {
        setOpenLoader(true);
        socket.emit('frontend:extraccion-turnos', data, response => {
            const { ok, message, data } = response;
            
            if(!ok) {
                // modalRef?.current?.handleClose();
                closeModal();
                setOpenLoader(false);
                alertRef?.current?.handleOpen('error', message);
                return;
            }

            const datos = [];

            data?.forEach(row => row?.transacciones?.forEach(t => {
                const objeto = {
                    turno: row?.turno,
                    fecha: dayjs(row?.creado).format('DD-MM-YYYY'),
                    sede: row?.sede?.nombre,
                    tiempo_espera: row?.tiempo_espera,
                    tiempo_atencion: t?.tiempo_atencion,
                    transaccion: t?.tramite?.nombre || 'ninguna',
                    tipo_observacion: t?.tipo_observacion?.nombre,
                    observacion: t?.observacion,
                    modulo: row?.modulo_nombre,
                    cajero: row?.cajero?.nombre,
                    tiempo_maximo_espera: row?.tiempo_maximo_espera ? 'revisar' : 'conforme',
                    tiempo_minimo_atencion: t?.tiempo_minimo_atencion ? 'revisar' : 'conforme',
                    tiempo_maximo_atencion: t?.tiempo_maximo_atencion ? 'revisar' : 'conforme'
                }
                datos?.push(objeto);
            }));

            // modalRef?.current?.handleClose();
            closeModal();
            setOpenLoader(false);
            exportarExcel(datos, `turnos${ dayjs().format('DDMMYYYY') }`)
        });
    }

    return (
        <form className={classes.form} onSubmit={handleSubmit(extraerTurnos)}>
            <Grid container spacing={ 2 }>
                <Grid item xs={ 10 } sm={ 10 } md={ 6 } lg={ 6 } xl={ 6 }>
                    <Controller 
                        name='inicial'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText
                                label='Desde'
                                type='date'
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.inicial }
                            />
                        )}
                        rules={{
                            required: '* La fecha inicial es requerida.'
                        }}
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 10 } md={ 6 } lg={ 6 } xl={ 6 }>
                    <Controller 
                        name='final'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText 
                                label='Hasta'
                                type='date'
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.final }
                            />
                        )}
                        rules={{
                            required: '* La fecha final es requerida.'
                        }}
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 12 } md={ 12 } lg={ 12 } xl={ 12 }>
                    <Controller 
                        name='sede'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSelect
                                label='Sede'
                                placeholder='Seleccione una sede'
                                options={sedes.map(a => ({ ...a, name: a?.nombre }))}
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.sede }
                                all='todas'
                            />
                        )}
                        rules={{
                            required: '* La sede es requerida.'
                        }}
                    />
                </Grid>
            </Grid>
           
            <CustomButtonsForm name='Generar'/>
        </form>
    )
}

const useStyles = makeStyles({
    form: {
        margin: '30px 30px 20px 30px', 
        position: 'relative',  
        width: 350
    }
});